import React from "react";
import styled from "styled-components";

function Table(props) {
  return <TableWrapper {...props} />;
}

export default Table;

const TableWrapper = styled.table.attrs((props) => {})`
  width: 1044px;
  border-top: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  border-spacing: 0px;
  border-collapse: collapse;
`;
